import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ExpenseVatActions } from './expense-vat.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ExpenseVatService } from '@core/services/expense-vat.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ExpenseVatEffects {
  private actions$ = inject(Actions);
  private expenseVatService = inject(ExpenseVatService);
  private translateService = inject(TranslateService);

  getExpenseVats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExpenseVatActions.loadExpenseVats),
      mergeMap((data) =>
        this.expenseVatService.getExpenseVats(data).pipe(
          map((response) => ExpenseVatActions.loadExpenseVatsSuccess(response)),
          catchError((error) =>
            of(
              ExpenseVatActions.loadExpenseVatsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addExpenseVat$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExpenseVatActions.addEditExpenseVat),
      mergeMap((data) =>
        this.expenseVatService.addExpenseVat(data).pipe(
          map((response) => {
            if (response.success) {
              return data.id
                ? ExpenseVatActions.updateExpenseVatSuccess(response)
                : ExpenseVatActions.addExpenseVatSuccess(response);
            }
            return ExpenseVatActions.addExpenseVatFailure(response);
          }),
          catchError((error) =>
            of(
              ExpenseVatActions.addExpenseVatFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteExpenseVat$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ExpenseVatActions.deleteExpenseVat),
      mergeMap((data) =>
        this.expenseVatService.deleteExpenseVat(data.id).pipe(
          map((response) =>
            response.success
              ? ExpenseVatActions.deleteExpenseVatSuccess({
                  ...response,
                  id: data.id,
                })
              : ExpenseVatActions.deleteExpenseVatFailure(response)
          ),
          catchError((error) =>
            of(
              ExpenseVatActions.deleteExpenseVatFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
